
const digest = '8745dd3d10d61cf8e010b20dcdc47d37268e0b9f54568b0564eebdc60d1c4117';
const css = `._dividerLine_yf9v2_1 {
  border-top: 1px solid var(--theme-secondary-border);
  margin-top: 20px;
  margin-bottom: 20px;
}

._selected_yf9v2_7 {
  border-top: 2px solid var(--aha-blue-500);
  margin-bottom: 19px;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"dividerLine":"_dividerLine_yf9v2_1","selected":"_selected_yf9v2_7"};
export { css, digest };
  